import { render, staticRenderFns } from "./InspectNew.vue?vue&type=template&id=32bfbbec&scoped=true"
import script from "./InspectNew.vue?vue&type=script&lang=ts"
export * from "./InspectNew.vue?vue&type=script&lang=ts"
import style0 from "./InspectNew.vue?vue&type=style&index=0&id=32bfbbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bfbbec",
  null
  
)

export default component.exports